// frontend/src/features/campaign/components/list/CampaignToolbar.js
import React from 'react';
import BlueprintPopover from './BlueprintPopover';
import CampaignStatusFilter from './CampaignStatusFilter';

export default function CampaignToolbar({
  searchQuery,
  onSearchChange,
  showBlueprints,
  onToggleBlueprints,
  onCloseBlueprints,
  onSelectPlaybook,
  onCreateCampaign,
  selectedStatus,
  onSelectStatus,
  statusCounts,
}) {
  return (
    <div className="cmp-toolbar-card">
      <div className="cmp-toolbar-top">
        {/* Search Box */}
        <div className="cmp-search-wrap">
          <i className="fas fa-search cmp-search-icon" aria-hidden="true" />
          <input
            type="text"
            className="cmp-search-input"
            placeholder="Search campaigns by title, objective, product, or target persona..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          {searchQuery && (
            <button
              className="cmp-search-clear"
              onClick={() => onSearchChange('')}
              title="Clear search"
            >
              <i className="fas fa-times" />
            </button>
          )}
        </div>

        {/* Quick Blueprint Dropdown Icon Button */}
        <BlueprintPopover
          isOpen={showBlueprints}
          onToggle={onToggleBlueprints}
          onClose={onCloseBlueprints}
          onSelectPlaybook={onSelectPlaybook}
        />

        {/* Create AI Campaign Strategy Button */}
        <button className="cmp-btn-primary cmp-btn-ai-glow" onClick={onCreateCampaign}>
          <span className="cmp-ai-sparkle-icon">
            <i className="fas fa-magic" />
          </span>
          <span>Create Campaign Strategy</span>
        </button>
      </div>

      {/* Status Filter Pills */}
      <CampaignStatusFilter
        selectedStatus={selectedStatus}
        onSelectStatus={onSelectStatus}
        statusCounts={statusCounts}
      />
    </div>
  );
}
